import { BlogPost } from '../types/blog';
import { blogPosts } from '../data/blog-posts';

export async function getAllPosts(): Promise<BlogPost[]> {
  return Promise.resolve(blogPosts);
}

export async function getPostBySlug(slug: string): Promise<BlogPost | null> {
  const post = blogPosts.find(p => p.slug === slug);
  return Promise.resolve(post || null);
}